import start from '@ikegps/client-ui';

start();
